import { Dispatch, SetStateAction, useMemo, VFC } from 'react'
import {
  SelectableItemDiv,
  SelectableItems,
} from 'src/compositions/Profile/formComponents/common'
import {
  MasterData,
  MasterDataWithRegionalDivisionType,
} from 'src/models/MasterData'
import { Persona } from 'src/models/Persona/index'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'
type PersonasContentProps = {
  personaData: Persona
  setPersonaData?: Dispatch<SetStateAction<Persona>>
  checkedBusinessTypes?: MasterData[]
  setCheckedBusinessTypes?: Dispatch<SetStateAction<MasterData[]>>
  checkedNumberOfEmployees?: MasterData[]
  setCheckedNumberOfEmployees?: Dispatch<SetStateAction<MasterData[]>>
  checkedNeeds?: MasterData[]
  setCheckedNeeds?: Dispatch<SetStateAction<MasterData[]>>
  checkedSolutions?: MasterData[]
  setCheckedSolutions?: Dispatch<SetStateAction<MasterData[]>>
  checkedPrefectures?: MasterDataWithRegionalDivisionType[]
  setCheckedPrefectures?: Dispatch<
    SetStateAction<MasterDataWithRegionalDivisionType[]>
  >
  checkedPositionNumberOptions?: MasterData[]
  setCheckedPositionNumberOptions?: Dispatch<SetStateAction<MasterData[]>>
  checkedCapitalNumberOptions?: MasterData[]
  setCheckedCapitalNumberOptions?: Dispatch<SetStateAction<MasterData[]>>
  checkedFoundedAts?: MasterData[]
  setCheckedFoundedAts?: Dispatch<SetStateAction<MasterData[]>>
  checkedBusinessObjects?: MasterData[]
  setCheckedBusinessObjects?: Dispatch<SetStateAction<MasterData[]>>
  checkedAdminAges?: MasterData[]
  setCheckedAdminAges?: Dispatch<SetStateAction<MasterData[]>>
  checkedRoleForAnalysis?: MasterData[]
  setCheckedRoleForAnalysis?: Dispatch<SetStateAction<MasterData[]>>
}
export const PersonasContent: VFC<PersonasContentProps> = ({
  personaData,
  setPersonaData,
  checkedBusinessTypes,
  setCheckedBusinessTypes,
  checkedNumberOfEmployees,
  setCheckedNumberOfEmployees,
  checkedNeeds,
  setCheckedNeeds,
  checkedSolutions,
  setCheckedSolutions,
  checkedPrefectures,
  setCheckedPrefectures,
  checkedPositionNumberOptions,
  setCheckedPositionNumberOptions,
  checkedCapitalNumberOptions,
  setCheckedCapitalNumberOptions,
  checkedFoundedAts,
  setCheckedFoundedAts,
  checkedBusinessObjects,
  setCheckedBusinessObjects,
  checkedAdminAges,
  setCheckedAdminAges,
  checkedRoleForAnalysis,
  setCheckedRoleForAnalysis,
}) => {
  const onClickBusinessTypes = async (id: number) => {
    if (checkedBusinessTypes && setCheckedBusinessTypes)
      setCheckedBusinessTypes(
        checkedBusinessTypes.filter((item) => Number(item.value) !== id),
      )
  }

  const onClickNumberOfEmployees = async (id: number) => {
    if (checkedNumberOfEmployees && setCheckedNumberOfEmployees)
      setCheckedNumberOfEmployees(
        checkedNumberOfEmployees.filter((item) => Number(item.value) !== id),
      )
  }

  const onClickNeeds = async (id: number) => {
    if (checkedNeeds && setCheckedNeeds)
      setCheckedNeeds(checkedNeeds.filter((item) => Number(item.value) !== id))
  }

  const onClickSolutions = async (id: number) => {
    if (checkedSolutions && setCheckedSolutions)
      setCheckedSolutions(
        checkedSolutions.filter((item) => Number(item.value) !== id),
      )
  }

  const onClickPrefectures = async (id: number) => {
    if (checkedPrefectures && setCheckedPrefectures)
      setCheckedPrefectures(
        checkedPrefectures.filter((item) => Number(item.value) !== id),
      )
  }

  const onClickPositionNumberOptions = async (id: number) => {
    if (checkedPositionNumberOptions && setCheckedPositionNumberOptions)
      setCheckedPositionNumberOptions(
        checkedPositionNumberOptions.filter(
          (item) => Number(item.value) !== id,
        ),
      )
  }

  const onClickCapitalNumberOptions = async (id: number) => {
    if (checkedCapitalNumberOptions && setCheckedCapitalNumberOptions)
      setCheckedCapitalNumberOptions(
        checkedCapitalNumberOptions.filter((item) => Number(item.value) !== id),
      )
  }

  const onClickIsListedCompany = async () => {
    if (setPersonaData)
      setPersonaData({
        ...personaData,
        isListedCompany: null,
      })
  }

  const onClickFoundedAts = async (id: number) => {
    if (checkedFoundedAts && setCheckedFoundedAts)
      setCheckedFoundedAts(
        checkedFoundedAts.filter((item) => Number(item.value) !== id),
      )
  }

  const onClickBusinessObjects = async (id: number) => {
    if (checkedBusinessObjects && setCheckedBusinessObjects)
      setCheckedBusinessObjects(
        checkedBusinessObjects.filter((item) => Number(item.value) !== id),
      )
  }

  const onClickAdminAges = async (id: number) => {
    if (checkedAdminAges && setCheckedAdminAges)
      setCheckedAdminAges(
        checkedAdminAges.filter((item) => Number(item.value) !== id),
      )
  }

  const onClickRoleForAnalysis = async (id: string) => {
    if (checkedRoleForAnalysis && setCheckedRoleForAnalysis)
      setCheckedRoleForAnalysis(
        checkedRoleForAnalysis.filter((item) => item.value !== id),
      )
  }

  const hasPersonaData = useMemo(() => {
    return (
      personaData.personaTypeOfBusinesses.length > 0 ||
      personaData.personaEmployeeNumbers.length > 0 ||
      personaData.personaCompanyBuyNeedOptions.length > 0 ||
      personaData.personaPrefectures.length > 0 ||
      personaData.personaPositions.length > 0 ||
      personaData.personaCapitals.length > 0 ||
      personaData.isListedCompany !== null ||
      personaData.personaFoundedAts.length > 0 ||
      personaData.personaBusinessObjects.length > 0 ||
      personaData.personaAdminAges.length > 0 ||
      personaData.minCreatedDate ||
      personaData.maxCreatedDate ||
      personaData.minLastSignInAt ||
      personaData.maxLastSignInAt ||
      personaData.personaRoleForAnalysis?.length > 0 ||
      personaData.personaSolutions.length > 0
    )
  }, [personaData])

  return (
    <Container>
      {!hasPersonaData ? (
        <NoContent>検索項目を設定してください</NoContent>
      ) : (
        <>
          {personaData.personaTypeOfBusinesses.length > 0 && (
            <>
              <Heading>業種</Heading>
              <SelectableItems>
                {personaData.personaTypeOfBusinesses.map((option) => (
                  <SelectableItemDiv
                    key={`businessTypes_${option.typeOfBusiness.id}`}
                  >
                    <label
                      onClick={() =>
                        onClickBusinessTypes(option.typeOfBusiness.id)
                      }
                    >
                      {option.typeOfBusiness.name}
                    </label>
                  </SelectableItemDiv>
                ))}
              </SelectableItems>
            </>
          )}
          {personaData.personaEmployeeNumbers.length > 0 && (
            <>
              <Heading>従業員数</Heading>
              <SelectableItems>
                {personaData.personaEmployeeNumbers.map((option) => (
                  <SelectableItemDiv
                    key={`numberOfEmployees_${option.employeeNumber.id}`}
                  >
                    <label
                      onClick={() =>
                        onClickNumberOfEmployees(option.employeeNumber.id)
                      }
                    >
                      {option.employeeNumber.name}
                    </label>
                  </SelectableItemDiv>
                ))}
              </SelectableItems>
            </>
          )}
          {personaData.personaCompanyBuyNeedOptions.length > 0 && (
            <>
              <Heading>ニーズ</Heading>
              <SelectableItems>
                {personaData.personaCompanyBuyNeedOptions.map((option) => (
                  <SelectableItemDiv
                    key={`needs_${option.companyBuyNeedOption.id}`}
                  >
                    <label
                      onClick={() =>
                        onClickNeeds(option.companyBuyNeedOption.id)
                      }
                    >
                      {option.companyBuyNeedOption.name}
                    </label>
                  </SelectableItemDiv>
                ))}
              </SelectableItems>
            </>
          )}
          {personaData.personaSolutions.length > 0 && (
            <>
              <Heading>ソリューション</Heading>
              <SelectableItems>
                {personaData.personaSolutions.map((option) => (
                  <SelectableItemDiv key={`solutions_${option.solution.id}`}>
                    <label onClick={() => onClickSolutions(option.solution.id)}>
                      {option.solution.name}
                    </label>
                  </SelectableItemDiv>
                ))}
              </SelectableItems>
            </>
          )}
          {personaData.personaPrefectures.length > 0 && (
            <>
              <Heading>所在地</Heading>
              <SelectableItems>
                {personaData.personaPrefectures.map((option) => (
                  <SelectableItemDiv
                    key={`prefectures_${option.prefecture.id}`}
                  >
                    <label
                      onClick={() => onClickPrefectures(option.prefecture.id)}
                    >
                      {option.prefecture.name}
                    </label>
                  </SelectableItemDiv>
                ))}
              </SelectableItems>
            </>
          )}
          {personaData.personaPositions.length > 0 && (
            <>
              <Heading>役職</Heading>
              <SelectableItems>
                {personaData.personaPositions.map((option) => (
                  <SelectableItemDiv key={`positions_${option.id}`}>
                    <label
                      onClick={() => onClickPositionNumberOptions(option.id)}
                    >
                      {option.name}
                    </label>
                  </SelectableItemDiv>
                ))}
              </SelectableItems>
            </>
          )}
          {personaData.personaCapitals.length > 0 && (
            <>
              <Heading>資本金</Heading>
              <SelectableItems>
                {personaData.personaCapitals.map((option) => (
                  <SelectableItemDiv key={`capitals_${option.id}`}>
                    <label
                      onClick={() => onClickCapitalNumberOptions(option.id)}
                    >
                      {option.name}
                    </label>
                  </SelectableItemDiv>
                ))}
              </SelectableItems>
            </>
          )}
          {personaData.isListedCompany !== null && (
            <>
              <Heading>上場・未上場</Heading>
              <SelectableItems>
                <SelectableItemDiv
                  key={
                    personaData.isListedCompany
                      ? 'is_listed_company'
                      : 'is_unlisted_company'
                  }
                >
                  <label onClick={() => onClickIsListedCompany()}>
                    {personaData.isListedCompany ? '上場' : '未上場'}
                  </label>
                </SelectableItemDiv>
              </SelectableItems>
            </>
          )}
          {personaData.personaFoundedAts.length > 0 && (
            <>
              <Heading>設立年数</Heading>
              <SelectableItems>
                {personaData.personaFoundedAts.map((option) => (
                  <SelectableItemDiv key={`foundedAts_${option.foundedAt.id}`}>
                    <label
                      onClick={() => onClickFoundedAts(option.foundedAt.id)}
                    >
                      {option.foundedAt.name}
                    </label>
                  </SelectableItemDiv>
                ))}
              </SelectableItems>
            </>
          )}
          {personaData.personaBusinessObjects.length > 0 && (
            <>
              <Heading>商材</Heading>
              <SelectableItems>
                {personaData.personaBusinessObjects.map((option) => (
                  <SelectableItemDiv
                    key={`businessObjects_${option.businessObject.id}`}
                  >
                    <label
                      onClick={() =>
                        onClickBusinessObjects(option.businessObject.id)
                      }
                    >
                      {option.businessObject.name}
                    </label>
                  </SelectableItemDiv>
                ))}
              </SelectableItems>
            </>
          )}
          {personaData.personaAdminAges.length > 0 && (
            <>
              <Heading>決裁者の年齢</Heading>
              <SelectableItems>
                {personaData.personaAdminAges.map((option) => (
                  <SelectableItemDiv key={`adminAges_${option.adminAge.id}`}>
                    <label onClick={() => onClickAdminAges(option.adminAge.id)}>
                      {option.adminAge.name}
                    </label>
                  </SelectableItemDiv>
                ))}
              </SelectableItems>
            </>
          )}
          {(personaData.minCreatedDate || personaData.maxCreatedDate) && (
            <>
              <Heading>登録日</Heading>
              <SelectableItems>
                <ItemDiv>
                  {personaData.minCreatedDate} ~ {personaData.maxCreatedDate}
                </ItemDiv>
              </SelectableItems>
            </>
          )}
          {(personaData.minLastSignInAt || personaData.maxLastSignInAt) && (
            <>
              <Heading>ログイン日時</Heading>
              <SelectableItems>
                <ItemDiv>
                  {personaData.minLastSignInAt} ~ {personaData.maxLastSignInAt}
                </ItemDiv>
              </SelectableItems>
            </>
          )}
          {personaData.personaRoleForAnalysis?.length > 0 && (
            <>
              <Heading>会員プラン</Heading>
              <SelectableItems>
                {personaData.personaRoleForAnalysis.map((option) => (
                  <SelectableItemDiv
                    key={`roleForAnalysis_${option.roleForAnalysis.id}`}
                  >
                    <label
                      onClick={() =>
                        onClickRoleForAnalysis(option.roleForAnalysis.id)
                      }
                    >
                      {option.roleForAnalysis.name}
                    </label>
                  </SelectableItemDiv>
                ))}
              </SelectableItems>
            </>
          )}
        </>
      )}
    </Container>
  )
}

const Container = styled.div`
  flex-wrap: wrap;
  overflow: scroll;
  ::-webkit-scrollbar:horizontal {
    height: 4px;
  }
  width: 100%;
`

const Heading = styled.p`
  color: #02b7b0;
  font-weight: ${fontWeightBold};
  margin: 8px 0 4px 0px;
  font-size: 14px;
`

export const ItemDiv = styled.div`
  font-weight: ${fontWeightBold};
`

const NoContent = styled.p`
  font-size: 14px;
  color: #cecdd1;
  text-align: center;
  font-weight: bold;
  padding-top: 120px;
`
